import React from "react";
import { withStyles } from "@material-ui/core/styles";

const styles = (theme) => ({
  container: {
    display: "flex",
    justifyContent: "space-between",
  },
  scHeader: {
    background: theme.ComponentHeader,
    boxShadow: "0px 3px 16px rgba(0, 0, 0, 0.12)",
    borderTopLeftRadius: "9px",
    borderTopRightRadius: "9px",
    color: theme.tooltipText,
    position: "relative",
    boxSizing: "border-box",
    display: "flex",
  },
  scHeaderName: {
    alignSelf: "center",
    flex: "1",
    userSelect: "none",
    padding: "10px",
    borderRadius: "5px",
    fontFamily: "Roboto",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: theme.textFontSize,
    lineHeight: "16px",
  },
  children: {
    display: "flex",
    alignItems: "center",
  }
});

const Header = ({ classes, title, children }) => (
  <div className={`${classes.scHeader} ${classes.container}`}>
    <div className={classes.scHeaderName}>{title}</div>
    <div className={classes.children}>{children}</div>
  </div>
);

export default withStyles(styles)(Header);
